module.exports = __webpack_public_path__ + "static/media/thomas.11c5e1cc.jpg";